import { FormElementAffiliationCodeOption } from './form-element-affiliation-code-option.model';
import { FormElement } from '../form-element.model';

export class FormElementAffiliationCode extends FormElement {
  AffCodeOptions: FormElementAffiliationCodeOption[];
  AffCodeTypeId: number;
  public constructor() {
    super();
    this.AffCodeOptions = [];
    this.ElementTypeId = 17;
    this.AffCodeTypeId = 0;
  }
}
